<template>
  <div class="add headFixed">
    <HeadNav title="故障报告"></HeadNav>

    <!-- 故障列表 -->
    <p class="freshTitle">系统故障</p>
    <p class="degreeBox">故障程度:<span class="degreeA">1级</span>
      <span class="degreeB">2级</span>
      <span class="degreeC">3级</span></p>
    <div class="list list_normal list_no_arrow list_info" v-if="alarmList && alarmList.length!=0">
      <div class="item" v-for="(item,index) of alarmList" :key="index">
        <div class="clear">
          <p :class="item.alarmLevel === 1?'degreeA':item.alarmLevel === 2?'degreeB':item.alarmLevel === 3?'degreeC':'degreeA'">
            {{ item.msg }}
            <span class="right">
									<span
                      :class="item.alarmLevel === 1?'degreeA':item.alarmLevel === 2?'degreeB':item.alarmLevel === 3?'degreeC':'degreeA'">{{
                      item.createTime
                    }}</span>
								</span>
          </p>
        </div>
      </div>
    </div>
    <div class="emptyData" v-show="alarmList==null||(alarmList&&alarmList.length<1)">
      暂无故障
    </div>
  </div>
</template>
<script>
import {Toast} from 'mint-ui';
import menu from '../menu/menu'
import HeadNav from '../headNav/headNav'

export default {
  name: 'add',
  data() {
    return {
      alarmList: null
    }
  },
  mounted() {
    this.getFaultList(1);
  },
  components: {
    'vMenu': menu,
    'HeadNav': HeadNav
  },
  methods: {
    getFaultList() {
      let str = this.$route.params.id
      this.Api.faultList(str, (msg) => {
        if (msg.code == 200) {
          this.alarmList = msg.data
        }
      });
    },
  }
}
</script>

<style scoped>
@import url('../../assets/list.css');

.faultTime {
  font-size: 12px;
  color: #969696;
  letter-spacing: 0.81px;
}

.degreeBox {
  text-align: right;
  padding: 0px 5px 5px;
}

.degreeA {
  color: green !important;
}

.degreeB {
  color: blue !important;
}

.degreeC {
  color: red !important;
}
</style>




// WEBPACK FOOTER //
// src/components/fault/fault.vue